import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { INVOICE } from '../../../../utils/ServiceUtils';
import { Order, toOrderXml } from '../../dataObjects/Order';
import { FilterInvoice, toFilterInvoiceXml } from '../../dataObjects/Invoice';
import { SoapUtils } from '../../../../utils/SoapUtils';

export interface ISumInvoiceRequest extends IBaseRequest {
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    id?: number;
    isIssued?: boolean;
    isOrder?: boolean;
    baseType?: string;
    orderByType?: string;
    treeHandle?: string;
    FILTER?: FilterInvoice;
    ORDER?: Order;
}

export class SumInvoiceRequest extends BaseRequest implements ISumInvoiceRequest {

    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    orderByType?: string;
    treeHandle?: string;
    FILTER?: FilterInvoice;
    ORDER?: Order;
    constructor(server: string, session: string, otherOptions?: any) {
        super(server, session);
        this.limit = otherOptions?.limit;
        this.offset = otherOptions?.offset;
        this.orderBy = otherOptions?.orderBy;
        this.countOnly = otherOptions?.countOnly;
        this.orderByType = otherOptions?.orderByType;
        this.treeHandle = otherOptions?.treeHandle;
        this.FILTER = otherOptions?.FILTER;
        this.ORDER = otherOptions?.ORDER;
  }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += SoapUtils.makeNode(this.limit, 'limit');
        parameters += SoapUtils.makeNode(this.offset, 'offset');
        parameters += SoapUtils.makeNode(this.orderBy, 'orderBy');
        parameters += SoapUtils.makeNode(this.countOnly, 'countOnly');
        parameters += SoapUtils.makeNode(this.orderByType, 'orderByType');
        parameters += SoapUtils.makeNode(this.treeHandle, 'treeHandle');
        parameters += toFilterInvoiceXml(this.FILTER);
        if(this.ORDER) parameters += toOrderXml(this.ORDER);
        return super.wrapperXml(INVOICE.sumInvoice, parameters);
    }
}
